import Component from "./Training";
export default Component;  
